import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiErrorDetail } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { KeyRound, Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";

// Tras un restablecimiento el usuario debe definir una contraseña nueva antes de usar el sistema
export default function ForcePasswordChange() {
  const { user, refresh, logout } = useAuth();
  const [f, setF] = useState({ current: "", pw: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.pw.length < 4) return toast.error("Mínimo 4 caracteres");
    if (f.pw !== f.confirm) return toast.error("Las contraseñas no coinciden");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.pw });
      toast.success("Contraseña actualizada");
      await refresh();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo cambiar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[190] grid place-items-center p-4 bg-slate-950/85 backdrop-blur-sm" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-2xl space-y-4 text-slate-900">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-emerald-100 grid place-items-center"><KeyRound className="text-emerald-600" size={22} /></div>
          <div>
            <h2 className="font-display font-bold text-lg leading-tight">Define tu nueva contraseña</h2>
            <p className="text-xs text-muted-foreground">Hola {user?.name}. Tu contraseña fue restablecida; elige una nueva para continuar.</p>
          </div>
        </div>
        <div><Label>Contraseña actual (temporal)</Label><Input type="password" required value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} className="mt-1" autoFocus data-testid="fpc-current" /></div>
        <div><Label>Nueva contraseña o PIN</Label><Input type="password" required value={f.pw} onChange={(e) => setF({ ...f, pw: e.target.value })} className="mt-1" placeholder="Mínimo 4 caracteres" data-testid="fpc-new" /></div>
        <div><Label>Confirmar nueva contraseña</Label><Input type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="mt-1" data-testid="fpc-confirm" /></div>
        <Button type="submit" disabled={busy || !f.current || !f.pw || !f.confirm} className="w-full h-11 bg-emerald-500 hover:bg-emerald-600 text-white font-bold" data-testid="fpc-save">
          {busy ? <Loader2 className="animate-spin" size={18} /> : "Guardar y continuar"}
        </Button>
        <button type="button" onClick={async () => { await logout(); window.location.href = "/login"; }} className="w-full flex items-center justify-center gap-1 text-xs text-muted-foreground hover:text-red-600" data-testid="fpc-logout"><LogOut size={12} /> Cerrar sesión</button>
      </form>
    </div>
  );
}
